import React, { useState } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import SortableHeading from "./SortableHeading";
import styles from "./style.module.scss";

const SortableTable = ({
  sorts,
  children,
  renderRow,
  buildingAdmin,
  styles: style,
  className,
  headings,
  defaultSort,
  defaultDirection,
  ...props
}) => {
  const [sortedColumnIndex, setSortedColumnIndex] = useState(defaultSort);
  const [reverseSort, setReverseSort] = useState(
    props.defaultDirection === "DESC"
  );

  const sortByColumn = (columnIndex) => {
    const hasSort = sorts[columnIndex];
    if (hasSort) {
      setSortedColumnIndex(columnIndex);
      setReverseSort(
        columnIndex === sortedColumnIndex ? !reverseSort : reverseSort
      );
    }
  };

  const defaultSortFunc = (key) => {
    return function sort(a, b) {
      if (a[key] < b[key]) return -1;
      if (a[key] > b[key]) return 1;
      return 0;
    };
  };
  let { data } = props;
  if (data && sorts[sortedColumnIndex]) {
    const inputSort = sorts[sortedColumnIndex];
    const sortFunc = // if sorts provide a function
      typeof inputSort === "function" ? inputSort : defaultSortFunc(inputSort);
    data = data.slice().sort(sortFunc);

    if (reverseSort) data.reverse();
  }

  let tbody;
  if (data && data.length > 0) {
    tbody = <tbody>{data.map(renderRow)}</tbody>;
    if (buildingAdmin) {
      tbody = data.map(renderRow);
    }
  } else if (children) {
    tbody = children;
    if (tbody.type === "tr") {
      tbody = <tbody>{tbody}</tbody>;
    } else if (tbody.type !== "tbody") {
      tbody = (
        <tbody>
          <tr>{tbody}</tr>
        </tbody>
      );
    }
  }

  const classNames = cn(style.table, className);

  return (
    <table className={classNames} style={style}>
      {data && data.length >= 0 && (
        <thead>
          <tr>
            {headings.map((title, index) => (
              <SortableHeading
                key={typeof title === "string" ? title : `null-${index}`}
                onClick={sortByColumn}
                orderColumn={sortedColumnIndex}
                orderDirection={reverseSort ? "DESC" : "ASC"}
                column={index}
                label={title}
              />
            ))}
          </tr>
        </thead>
      )}
      {tbody}
    </table>
  );
};

export default SortableTable;

SortableTable.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  data: PropTypes.array.isRequired,
  headings: PropTypes.arrayOf(PropTypes.string),
  sorts: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.func])
  ),
  styles: PropTypes.shape({}),
  defaultSort: PropTypes.number,
  buildingAdmin: PropTypes.bool,
  defaultDirection: PropTypes.oneOf(["DESC", "ASC"]),
  className: PropTypes.string,
  children: PropTypes.node,
  renderRow: PropTypes.func.isRequired,
};

SortableTable.defaultProps = {
  sorts: [],
  headings: [],
  defaultSort: -1,
  styles,
  buildingAdmin: false,
  defaultDirection: "ASC",
  className: null,
  children: null,
};
